import { productDeleteApi } from "../../api/product/productDeleteApi"

export async function productDeleteService(payload: { id: string }, token: string) {
	return await productDeleteApi(payload, token)
}
